module.exports = __webpack_public_path__ + "facebook-rounded-8e3e5e1af7aa91fb7749.svg";